// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: 'fafb262403849d799a9bc9441bb9163f7f04d57f',
  short: 'fafb262',
  builtAt: '2026-11-03T16:55:13.838Z',
} as const;
